(function () {
    'use strict';
    angular.module('app.bpmn', []);
})();
